import { useRouterState } from "@tanstack/react-router";
import { useLayoutEffect } from "react";

/** Signal from committed destination content, never from auth or React mount alone. */
export function useInitialSplashReady(ready = true) {
  const settled = useRouterState({
    select: (state) => state.status === "idle" && !state.isLoading && !state.isTransitioning,
  });

  useLayoutEffect(() => {
    const splash = document.getElementById("qotta-startup-splash");
    if (!ready || !settled || !splash || splash.hasAttribute("data-leaving")) return;

    // The destination has committed. Start revealing it at the next paint; no dwell timer.
    const frame = requestAnimationFrame(() => {
      const root = document.getElementById("root");
      if (root) {
        root.inert = false;
        root.removeAttribute("aria-hidden");
      }
      splash.setAttribute("aria-hidden", "true");
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        splash.remove();
        return;
      }
      const remove = (event: TransitionEvent) => {
        if (event.target !== splash || event.propertyName !== "opacity") return;
        splash.removeEventListener("transitionend", remove);
        splash.removeEventListener("transitioncancel", remove);
        splash.remove();
      };
      splash.addEventListener("transitionend", remove);
      splash.addEventListener("transitioncancel", remove);
      splash.setAttribute("data-leaving", "");
    });
    return () => cancelAnimationFrame(frame);
  }, [ready, settled]);
}
